<template>
  <MultiLevelNavigationModal
    v-model="localValue"
    :modal-title="$t('selectGlobalAttribute')"
    :fetch-branches="getNoBranches"
    :fetch-leaves="getGlobalAttributes"
    :selected-entry-id="selectedEntryId"
    :selectable-type="['leaf']"
    :base-path-title="$t('global.attributes')"
    with-all
    @confirm="onConfirm"
    @hide="emits('hide')"
    @cancel="emits('cancel')"
    @close="emits('close')" />
</template>

<script setup lang="ts">
import { useContentLanguages } from "@common/composable/useMetaDataStore";
import { GlobalAttribute } from "@medapro-types/common/common";
import { Branch, Leaf, MultiLevelNavigationConfirmModel } from "@medapro-types/common/components/MultiLevelNavigation";
import globalAttributesApi from "@services/globalAttributes.js";
import { computed } from "vue";
import MultiLevelNavigationModal from "./MultiLevelNavigationModal.vue";

const LEAF_ICON = "Attribute";

//#region General
const emits = defineEmits(["confirm", "input", "cancel", "close", "hide"]);

const props = defineProps<{ value: boolean; selectedEntryId: string | null | undefined }>();
//#endregion

//#region Store
const { primaryLanguageCode } = useContentLanguages();
//#endregion

const onConfirm = (event: MultiLevelNavigationConfirmModel) => {
  emits("confirm", event);
};

//#region localValue
const localValue = computed({
  get: () => props.value,
  set: (nv) => emits("input", nv)
});

//#endregion

//#region FetchMethods
const getNoBranches = async (): Promise<Branch[]> => {
  return [];
};

const getGlobalAttributes = async (): Promise<Leaf[]> => {
  const fetchResult: Record<string, GlobalAttribute>[] = await globalAttributesApi.get([primaryLanguageCode.value]);

  return fetchResult.map((x) => ({
    id: x[primaryLanguageCode.value].globalAttributeId,
    name: x[primaryLanguageCode.value].name,
    dataType: x[primaryLanguageCode.value].dataType,
    icon: LEAF_ICON
  }));
};
//#endregion
</script>
